import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconCloudSnow(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.339 11.72a.666.666 0 0 1-.268-1.277 2.655 2.655 0 0 0 1.414-1.472 2.668 2.668 0 0 0-2.48-3.638h-.839a.666.666 0 0 1-.645-.5C9.878 2.342 7.327.838 4.836 1.482S.841 4.675 1.484 7.167a4.694 4.694 0 0 0 1.605 2.479.666.666 0 1 1-.832 1.042A6.03 6.03 0 0 1 .193 7.501 6.006 6.006 0 0 1 4.502.192a6.007 6.007 0 0 1 7.157 3.809h.347a4.002 4.002 0 0 1 3.721 5.456 3.975 3.975 0 0 1-2.121 2.208.647.647 0 0 1-.267.056zm-8.001-1.053a.66.66 0 0 1-.613-.919.683.683 0 0 1 .14-.22.678.678 0 0 1 .727-.14c.08.033.153.08.22.14.06.067.107.14.14.22s.053.167.053.253a.66.66 0 0 1-.666.666zm0 2.667a.66.66 0 0 1-.473-.193c-.06-.067-.107-.14-.14-.22s-.053-.167-.053-.253a.7.7 0 0 1 .193-.473c.253-.247.7-.247.947 0a.7.7 0 0 1 .193.473.556.556 0 0 1-.053.253.767.767 0 0 1-.14.22.662.662 0 0 1-.473.193zM8.005 12a.66.66 0 0 1-.613-.919.767.767 0 0 1 .14-.22c.033-.027.067-.06.1-.08a.48.48 0 0 1 .12-.06.666.666 0 0 1 .727.14c.06.067.107.133.14.22a.66.66 0 0 1-.613.919zm0 2.667c-.087 0-.173-.02-.253-.053s-.153-.08-.22-.14a.658.658 0 0 1-.14-.726.683.683 0 0 1 .14-.22.698.698 0 0 1 .947 0 .7.7 0 0 1 .193.473.66.66 0 0 1-.666.666zm2.666-4a.659.659 0 0 1-.613-.919.683.683 0 0 1 .14-.22.664.664 0 0 1 .726-.14c.039.013.08.033.12.06.033.02.067.053.1.08.06.067.107.133.14.22a.66.66 0 0 1-.613.919zm0 2.667a.659.659 0 0 1-.473-.193.983.983 0 0 1-.147-.22.7.7 0 0 1 .147-.726c.247-.247.693-.247.947 0a.7.7 0 0 1 .193.473c0 .087-.02.173-.053.253s-.08.153-.14.22a.662.662 0 0 1-.473.193z"
  }));
}
IconCloudSnow.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconCloudSnow.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconCloudSnow as default };
